const EmploymentDetails =() => {
// News Removals Start

  


// News Removals End

  return (

      <div>
        <div className="general-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title top-cap-outlines">
                <h2>Employment Opportunity</h2>
            </div>
            {/*End Large Image Space*/}
            {/*Start Main Content*/}
            <div className="content-fluid">

                <div className="mb-960-center-container mid-side-outlines mobile-pad-1em">
                    {/*Full Width Element*/}
                    <div className="mb-960-col-50p">
<p>
                        <h4>Borough Openings</h4>
                        
                        <div className="container accordion-container">
                                      <div className="accordion" id="latestNewsAccordion">
                                        {/* ADD IMPORTED NEWS BELOW */}


                                        12/10/25 - No listings at this time
                                       
                                        {/* END IMPORTED NEWS ITEMS */}
                                      </div>
                                    </div>
                                    {/*Accordion End - News*/}
                                    </p>
                        <p>
                            <br/>
                        <h4>Police Openings</h4>
                        Openings with the Morrisville Police are listed on the <a href="./police/jobs">Police Job Openings </a> page.
                        </p>
                    <br/>
                        <h4>Equal Opportunity Employer</h4>
                        <p>
                            Morrisville Borough adheres to all federal and Pennsylvania state laws to protect individuals from discrimination in hiring, discharge, promotion, pay, fringe benefits, job training, referral and other aspects of employment, on the basis of race, color, national origin, religion, sex (including pregnancy) or disability.
                        </p>
                    </div>

                    <div className="mb-960-col-50p">

                        <h4>Related Documents</h4>
                        <table id="filetable">
                            <tr>
                                <th>File Name</th>
                                <th>Date Posted</th>

                            </tr>
                            {/*Start File*/}
                            <tr>

                                <td><a href="../docs/employment/Borough-of-Morrisville-Employment-Application.pdf">
                                        <i className="fa-solid fa-file-pdf fa-xl"></i>&nbsp;
                                        Non-Police Employment Application</a></td>
                                <td>09/17/2024</td>
                            </tr>
                            {/*End File*/}

                        </table>
                    </div>

                </div>
            </div>
        
        <div className="page-footer bottom-cap-outlines">&nbsp;</div>
        <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>

</div>
        </div>

    )
};
export default EmploymentDetails;